import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d791581e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ShopWindow"
}
const _hoisted_2 = { class: "ShopWindow-shop" }
const _hoisted_3 = { class: "ShopWindow-shop-img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "ShopWindow-shop-msg" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "title-text" }
const _hoisted_8 = ["title"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "enter" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-caret-right",
  style: {"margin-left":"6px"}
}, null, -1))
const _hoisted_12 = { class: "ShopWindow-goods" }
const _hoisted_13 = { class: "ShopWindow-goods-item" }
const _hoisted_14 = { class: "ShopWindow-goods-item-pic" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { style: {"font-size":"14px"} }

import { reactive } from 'vue'
import { t } from '@/plugins/i18n'
import PopBtn from '@/components/common/PopBtn.vue'
import { useRtfix, useSite2Station } from '@/store'
import { useRouter } from 'vue-router'
import ShopItemAction from '@/components/common/ShopItemAction.vue'
import LogoIcon from '@/components/common/LogoIcon.vue'
import { bury } from '@/util/useBury'
import { formatMoneyDirection, calc } from '@/util/useYan'
import { Site } from '@/common/const'


export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object,
    default: null
  },
  // 前端展示场景 1-搜索列表;2-猜你喜欢;3-店铺商品列表;4-商品详情;5-收藏;6-已购买;7-足迹;8-担当推荐;9-系统推荐;10-找相似;11-关联商品;12-市场爆款
  showChannel: {
    type: Number,
    default: null
  }
},
  emits: ['unlike'],
  setup(__props, { emit: emits }) {

const props = __props
const stationCode = useSite2Station()
const router = useRouter()



const data = reactive({
  defaultImg: require('@/assets/image/shop-bg-default.webp')
})



// 不喜欢操作回调
const unlike = (shopCode: string) => {
  emits('unlike', shopCode)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (__props.item)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(PopBtn, { offset: "100%" }, {
            pop: _withCtx(() => [
              _createVNode(ShopItemAction, {
                item: __props.item,
                showChannel: __props.showChannel,
                onUnlike: unlike
              }, null, 8, ["item", "showChannel"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  referrerPolicy: "no-referrer",
                  class: "wrap",
                  src: __props.item.shopMainImg ? __props.item.shopMainImg : _unref(data).defaultImg,
                  alt: ""
                }, null, 8, _hoisted_4)
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(LogoIcon, {
                class: "mr_5",
                type: __props.item.platformType,
                url: __props.item.productDetailUrl
              }, null, 8, ["type", "url"]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(__props.item.shopName ? __props.item.shopName : ' - '), 1)
            ]),
            (__props.item.shopMajorCateName)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "category",
                  title: __props.item.shopMajorCateName.replace(/,/g, '、')
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.shopMajorCateName.split(','), (i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                      (i !== '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(i), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 8, _hoisted_8))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: _unref(useRtfix)('list', { query: { shopCode: __props.item.shopCode } })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "enter-btn",
                    round: "",
                    size: "large",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(bury)('MyChannel_Click_RecommendShopJoin')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('进入店铺')) + " ", 1),
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (
          __props.item.recommendProductList && __props.item.recommendProductList.length !== 0
        )
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.item.recommendProductList.slice(0, 8), (goods) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: goods.productCode,
                  to: _unref(useRtfix)('goods', { params: { id: goods.productCode } }),
                  onClick: ($event: any) => (
            _unref(bury)(
              'MyChannel_Click_RecommendShopGoods',
              __props.item.shopName,
              goods.productCode
            )
          )
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("img", {
                          referrerPolicy: "no-referrer",
                          "data-goods": "",
                          class: "wrap",
                          src: goods.productMainImg,
                          alt: goods.productTitle
                        }, null, 8, _hoisted_15)
                      ]),
                      _createElementVNode("div", {
                        class: "ShopWindow-goods-item-price",
                        style: _normalizeStyle(`color: ${_unref(stationCode) === _unref(Site).KO ?'black' : 'red'} ; ` )
                      }, [
                        _createElementVNode("span", null, _toDisplayString(`${goods.productSellPrice}${_unref(t)('元')}`), 1),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(`(${_unref(formatMoneyDirection)(
                  _unref(calc)(goods.productSellPrice)
                )})`), 1)
                      ], 4)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to", "onClick"]))
              }), 128))
            : (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                class: "ShopWindow-goods-empty",
                description: _unref(t)('没有更多了')
              }, null, 8, ["description"]))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})